import { connect } from 'react-redux';

import DeativeOrDeleteBranchDialog from '../../components/DeativeOrDeleteBranchDialog';
import {
  showDeleteOrDeactiveBranchDialogStateChanged,
  DeactiveOrDeleteBranchDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  const branchId = state.branch.deleteOrDeactivatingBranch.branchId;
  const allBranches = state.branches.allBranches.items;
  const selectedBranch =
    branchId === 0 ? {} : allBranches.filter((e) => e.id === branchId)[0];

  return {
    branch: selectedBranch,
    open: state.branch.deleteOrDeactivatingBranch.open,
    isUpdating: state.branch.deleteOrDeactivatingBranch.isSaving,
    errorMessage: state.branch.deleteOrDeactivatingBranch.errorMessage,
    status: state.branch.deleteOrDeactivatingBranch.status
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    showDialog: (open, branchId, status) => {
      dispatch(
        showDeleteOrDeactiveBranchDialogStateChanged(open, branchId, status)
      );
    },
    onConfirmEmloyerStatusUpdate: (branch) => {
      dispatch(DeactiveOrDeleteBranchDispatch(branch));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeativeOrDeleteBranchDialog);
